<template>
  <div class="real-auth-result" :class="{ check: isCheckApp, hunter: isHunterApp }">
    <img v-if="result" :src="$setPicSize(successImg)" />
    <img v-if="!result" :src="$setPicSize(failImg)" />
    <div class="result-info">
      <header>您的申请已提交成功，请耐心等待</header>
    </div>
    <div class="operation-area">
      <div class="quit highlight" @click="quit"><span>关闭</span></div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { queryParams, isCheckApp, isHunterApp } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'CommitResult',
  data() {
    return {
      from: query.from || this.$route.query.from,
      strategyid: query.strategyid || this.$route.query.strategyid,
      servicetype: query.servicetype || this.$route.query.servicetype,
      result: true,
      isCheckApp,
      isHunterApp,
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png'
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    adapterOS() {
      if (isCheckApp) {
        this.successImg = 'n_v240eae3d853a749dea0235916fb469918.png'
        this.failImg = 'n_v23dcff40005ca49e5ac688d6b03c99549.png'
      }
      if (isHunterApp) {
        this.successImg = 'n_v22b700e1a672d4efcb1b00ce4207c11c9.png'
        this.failImg = 'n_v23e94a6f9c8f34a5e98c65a7e12f7ffe2.png'
      }
    },
    quit() {
      native.close()
    }
  },
  created() {
    native.setTitle({
      title: '实人认证'
    })

    lego.send({
      pagetype: 'ZZUP_REALAUTH_COMMITRESULT',
      actiontype: 'PAGE_SHOW',
      backup: {
        from: this.from,
        strategyid: this.strategyid,
        servicetype: this.servicetype
      }
    })
    this.adapterOS()
  }
}
</script>

<style lang="less" scoped>
  @import './CommitResult.less';
</style>
